import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-luxon";
import { DateTime } from "luxon";
import Modal from "react-bootstrap/Modal";
import DateLabels from "./DateLabels";
import { getColours, getDarkColour, getLightColour } from "./Util";

ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  DateLabels
);

export default function FlowModal(props) {
  const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: false,
      },
      tooltip: {
        mode: "index",
        itemSort: (a, b) => {
          return a.dataSetIndex > b.dataSetIndex ? 1 : -1;
        },
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label = label + ": ";
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y + " MW";
            }
            return label;
          },
          footer: function (tooltipItems) {
            let sum = 0;
            tooltipItems.forEach(function (tooltipItem) {
              sum += tooltipItem.parsed.y;
            });
            let index = tooltipItems[0].dataIndex;
            return (
              "Production: " +
              props.production[index].y +
              " GW\nDemand: " +
              props.demand[index].y +
              " GW\nNet Flow: " +
              sum +
              " MW"
            );
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    layout: {
      padding: {
        bottom: 20,
      },
    },
    scales: {
      x: {
        type: "time",
        adapters: {
          date: {
            zone: "Canada/Mountain",
          },
        },
        time: {
          unit: "day",
          displayFormats: {
            hour: DateTime.DATE_SHORT,
          },
          tooltipFormat: DateTime.DATETIME_FULL,
        },
        grid: {
          offset: false,
        },
        ticks: {
          callback: (label) => "",
        },
      },
      y: {
        ticks: {
          callback: (label) => `${label} MW`,
        },
        stacked: true,
      },
    },
  };

  let graphData = {
    datasets: [
      {
        label: "BC Tie",
        data: props.tieBC,
        borderColor: getDarkColour(),
        pointRadius: 0,
        backgroundColor: getDarkColour(),
        cubicInterpolationMode: "monotone",
        fill: true,
        order: 3,
      },
      {
        label: "SK Tie",
        data: props.tieSK,
        borderColor: getColours()[3],
        pointRadius: 0,
        backgroundColor: getColours()[3],
        cubicInterpolationMode: "monotone",
        fill: true,
        order: 2,
      },
      {
        label: "Montana Tie",
        data: props.tieMontana,
        borderColor: getColours()[6],
        pointRadius: 0,
        backgroundColor: getColours()[6],
        cubicInterpolationMode: "monotone",
        fill: true,
        order: 1,
      },
    ],
  };

  return (
    <Modal
      show={props.show}
      onHide={props.close}
      dialogClassName="historyModal"
      centered
    >
      <Modal.Header style={{ backgroundColor: getLightColour() }} closeButton>
        <Modal.Title>Energy Flow History (MW)</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: props.height + "px" }}>
        <Line options={graphOptions} data={graphData} />
      </Modal.Body>
    </Modal>
  );
}
